'use client';

import { useSearchParams } from 'next/navigation';
import { useEffect } from 'react';

import {
  isForwardLoop,
  movedStudioUrl,
  requestedSearch,
} from '@/lib/tenant-host';

// A browser-side forward, not a 301: moved answers are cached per address, so
// two addresses holding stale answers that name each other would forward a
// visitor between them without end, and only the browser knows where it
// arrived from. A 301 would also outlive a rename back in the browser's cache.
// The server reads the query from useSearchParams, so the link a browser
// without JavaScript follows keeps it too. When the forward would loop, only
// the link is shown.
export const MovedStudioRedirect = ({
  slug,
  pathname,
  fullScreen,
}: {
  slug: string;
  pathname: string;
  fullScreen?: boolean;
}) => {
  const url = movedStudioUrl(
    slug,
    pathname,
    requestedSearch(useSearchParams().toString())
  );
  const href = url.href;

  useEffect(() => {
    if (!isForwardLoop(document.referrer, new URL(href))) {
      window.location.replace(href);
    }
  }, [href]);

  return (
    <div
      className={
        fullScreen
          ? 'flex min-h-screen items-center justify-center bg-olive-25 px-4 py-16'
          : 'flex min-h-60 items-center justify-center p-6'
      }
    >
      <p className="text-center text-sm leading-5 text-gray-700">
        This booking page moved to{' '}
        <a href={href} className="font-semibold text-gray-900 underline">
          {url.host}
        </a>
      </p>
    </div>
  );
};
